var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svgPath)?_c('div',[_c('img',{staticClass:"rounded-md shadow-md",attrs:{"src":_vm.svgPath,"alt":"flag","loading":"lazy","width":"64"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }